import { CaseLookupStatus } from '../../../api-service/clients/auto-generated-clients';

export function caseStatusLabel(status: CaseLookupStatus): string {
  switch (status) {
    case CaseLookupStatus.Active:
      return 'Aktiv';
    case CaseLookupStatus.Finished:
      return 'Afsluttet';
    case CaseLookupStatus.NeedsToBeTerminated:
      return 'Skal afsluttes';
    default:
      return '';
  }
}

export function formatCaseLabel(caseName: string | undefined, status: CaseLookupStatus | undefined, showStatus: boolean): string {
  if (!caseName) return '';
  if (!showStatus || status === undefined) return caseName;
  const statusText = caseStatusLabel(status);
  return statusText ? `${caseName} (${statusText})` : caseName;
}
